"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikTextFormatterWidget = exports.useFormikTextFormatterWidget = exports.FormikRadioButtonGroup = exports.FormikSingleSelectDropdown = exports.FormikCheckBoxWidget = exports.FormikToggleSwitch = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
function getValidFromMeta({ touched, error }, subtleValid) {
    if (!touched) {
        return undefined;
    }
    else if (error) {
        return false;
    }
    else if (subtleValid) {
        return undefined;
    }
    else {
        return true;
    }
}
function useWidgetFormikField(params) {
    const [field, meta, helpers] = (0, formik_1.useField)(Object.assign({}, params.config));
    const { isSubmitting } = (0, formik_1.useFormikContext)();
    const disabled = params.disabled || isSubmitting || undefined;
    const valid = getValidFromMeta(meta, params.subtleValid);
    return { field, meta, helpers, glue: { disabled, valid, testId: field.name } };
}
function FormikToggleSwitch(_a) {
    var { config, disabled, subtleValid } = _a, props = tslib_1.__rest(_a, ["config", "disabled", "subtleValid"]);
    const [field, meta, helpers] = (0, formik_1.useField)(config);
    const { isSubmitting } = (0, formik_1.useFormikContext)();
    const onChange = react_1.default.useCallback((e) => {
        helpers.setValue(e.target.checked);
        helpers.setTouched(field.value !== meta.initialValue);
    }, [helpers, meta, field]);
    return (react_1.default.createElement(widgets_1.ToggleSwitchWidget, Object.assign({ checked: field.value, testId: field.name, onChange: onChange, disabled: disabled || isSubmitting }, props)));
}
exports.FormikToggleSwitch = FormikToggleSwitch;
function FormikCheckBoxWidget(_a) {
    var { config, disabled, subtleValid } = _a, props = tslib_1.__rest(_a, ["config", "disabled", "subtleValid"]);
    const [field, , helpers] = (0, formik_1.useField)(config);
    const { isSubmitting } = (0, formik_1.useFormikContext)();
    const initial = react_1.default.useRef(field.value);
    const onChange = react_1.default.useCallback((e) => {
        helpers.setValue(e.target.checked);
        helpers.setTouched(field.value !== initial.current);
    }, [helpers, initial, field]);
    return (react_1.default.createElement(widgets_1.CheckBoxWidget, Object.assign({ checked: !!field.value, testId: field.name, onChange: onChange, disabled: disabled || isSubmitting }, props)));
}
exports.FormikCheckBoxWidget = FormikCheckBoxWidget;
function FormikSingleSelectDropdown(_a) {
    var { config, disabled, subtleValid } = _a, props = tslib_1.__rest(_a, ["config", "disabled", "subtleValid"]);
    const preventFormikFromConsideringDropdownSubmit = (ref) => {
        // eslint-disable-next-line react/no-find-dom-node
        const buttonEl = ref ? react_dom_1.default.findDOMNode(ref) : undefined;
        if (buttonEl) {
            buttonEl.setAttribute('name', config.name);
            buttonEl.setAttribute('type', 'button');
        }
    };
    const { field, glue, helpers, meta } = useWidgetFormikField({ config, disabled, subtleValid });
    const onChange = react_1.default.useCallback((value) => {
        helpers.setValue(value);
        helpers.setTouched(value !== meta.initialValue);
    }, [helpers, meta.initialValue]);
    return (react_1.default.createElement(widgets_1.SingleSelectDropdown, Object.assign({ type: widgets_1.DropdownButtonType.Outline, value: field.value, onChange: onChange }, glue, { testId: `${config.name}-dropdown`, buttonRef: preventFormikFromConsideringDropdownSubmit }, props)));
}
exports.FormikSingleSelectDropdown = FormikSingleSelectDropdown;
function FormikRadioButtonGroup(_a) {
    var { config, disabled, subtleValid } = _a, props = tslib_1.__rest(_a, ["config", "disabled", "subtleValid"]);
    const { field, glue, helpers } = useWidgetFormikField({ config, disabled, subtleValid });
    const index = props.buttonList.findIndex(button => button.value === field.value);
    const initialRef = react_1.default.useRef(index);
    const handleChange = react_1.default.useCallback((value, checkedIndex) => {
        if (!glue.disabled) {
            helpers.setValue(value);
            helpers.setTouched(checkedIndex !== initialRef.current);
        }
    }, [helpers, initialRef, glue]);
    return (react_1.default.createElement(widgets_1.RadioButtonWithLabelGroupWidget, Object.assign({ "aria-disabled": disabled, checkedIndex: index, handleChange: handleChange, testId: glue.testId }, props)));
}
exports.FormikRadioButtonGroup = FormikRadioButtonGroup;
function useFormikTextFormatterWidget(_a) {
    var _b, _c;
    var { config, disabled, subtleValid, message } = _a, props = tslib_1.__rest(_a, ["config", "disabled", "subtleValid", "message"]);
    const { field, glue, helpers, meta } = useWidgetFormikField({
        config,
        disabled,
        subtleValid,
    });
    const { setValue } = helpers;
    const onChange = react_1.default.useCallback((e) => { var _a, _b; return setValue((_b = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '', true); }, [setValue]);
    const element = (react_1.default.createElement(widgets_1.TextFormatterWidget, Object.assign({ markup: (_b = field.value) !== null && _b !== void 0 ? _b : '', onChange: onChange, disabled: glue.disabled, testId: glue.testId, valid: glue.valid, message: (_c = meta.error) !== null && _c !== void 0 ? _c : (message && message(field.value)) }, props)));
    return { onChange, element };
}
exports.useFormikTextFormatterWidget = useFormikTextFormatterWidget;
function FormikTextFormatterWidget(props) {
    const { element } = useFormikTextFormatterWidget(props);
    return element;
}
exports.FormikTextFormatterWidget = FormikTextFormatterWidget;
//# sourceMappingURL=FormikWidgets.js.map